import { render, staticRenderFns } from "./OrdersReport.vue?vue&type=template&id=7938a20f"
import script from "./OrdersReport.vue?vue&type=script&lang=ts"
export * from "./OrdersReport.vue?vue&type=script&lang=ts"
import style0 from "./OrdersReport.vue?vue&type=style&index=0&id=7938a20f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports